import AdminAPI from "../../services/AdminAPI";
import { getActiveAcademicYear } from "../sdp/utils";

const year = () => encodeURIComponent(getActiveAcademicYear());
const base = "/admin/admission-booster";
const query = (params = {}) => {
  const values = new URLSearchParams({ academic_year: getActiveAcademicYear() });
  Object.entries(params).forEach(([key, value]) => value !== undefined && value !== null && value !== "" && values.set(key, value));
  return `?${values.toString()}`;
};

export const admissionApi = {
  dashboard: () => AdminAPI.get(`${base}/dashboard?academic_year=${year()}`),
  settings: () => AdminAPI.get(`${base}/settings?academic_year=${year()}`),
  saveSettings: (body) => AdminAPI.patch(`${base}/settings?academic_year=${year()}`, body),
  leads: (params) => AdminAPI.get(`${base}/leads${query(params)}`),
  createLead: (body) => AdminAPI.post(`${base}/leads?academic_year=${year()}`, body),
  updateLead: (id, body) => AdminAPI.patch(`${base}/leads/${id}?academic_year=${year()}`, body),
  archiveLead: (id) => AdminAPI.delete(`${base}/leads/${id}?academic_year=${year()}`),
  moveLead: (id, body) => AdminAPI.patch(`${base}/leads/${id}/stage?academic_year=${year()}`, body),
  leadHistory: (id) => AdminAPI.get(`${base}/leads/${id}/history?academic_year=${year()}`),
  tasks: (params) => AdminAPI.get(`${base}/tasks${query(params)}`),
  createTask: (body) => AdminAPI.post(`${base}/tasks?academic_year=${year()}`, body),
  updateTask: (id, body) => AdminAPI.patch(`${base}/tasks/${id}?academic_year=${year()}`, body),
  completeTask: (id, completed) => AdminAPI.patch(`${base}/tasks/${id}/completion?academic_year=${year()}`, { completed }),
  archiveTask: (id) => AdminAPI.delete(`${base}/tasks/${id}?academic_year=${year()}`),
  activityLibrary: (params = {}) => AdminAPI.get(`${base}/activity-library${query(params)}`),
  projects: (params) => AdminAPI.get(`${base}/content-projects${query(params)}`),
  createProject: (body) => AdminAPI.post(`${base}/content-projects?academic_year=${year()}`, body),
  updateProject: (id, body) => AdminAPI.patch(`${base}/content-projects/${id}?academic_year=${year()}`, body),
  patchProject: (id, segment, body) => AdminAPI.patch(`${base}/content-projects/${id}/${segment}?academic_year=${year()}`, body),
  archiveProject: (id) => AdminAPI.delete(`${base}/content-projects/${id}?academic_year=${year()}`),
  generateIdeas: (id) => AdminAPI.post(`${base}/content-projects/${id}/ai-ideas?academic_year=${year()}`, {}),
  assets: (id) => AdminAPI.get(`${base}/content-projects/${id}/assets?academic_year=${year()}`),
  uploadAsset: (id, file) => { const data = new FormData(); data.append("file", file); return AdminAPI.uploadFile(`${base}/content-projects/${id}/assets?academic_year=${year()}`, data); },
  deleteAsset: (id) => AdminAPI.delete(`${base}/assets/${id}?academic_year=${year()}`),
  downloadBrief: (id) => AdminAPI.downloadFile(`${base}/content-projects/${id}/brief/download?academic_year=${year()}`, "admission-content-brief.txt"),
  publications: () => AdminAPI.get(`${base}/publications?academic_year=${year()}`),
  createPublication: (body) => AdminAPI.post(`${base}/publications?academic_year=${year()}`, body),
  updatePublication: (id, body) => AdminAPI.patch(`${base}/publications/${id}?academic_year=${year()}`, body),
  deletePublication: (id) => AdminAPI.delete(`${base}/publications/${id}?academic_year=${year()}`),
  calendar: (params) => AdminAPI.get(`${base}/calendar${query(params)}`),
  createCalendar: (body) => AdminAPI.post(`${base}/calendar?academic_year=${year()}`, body),
  updateCalendar: (id, body) => AdminAPI.patch(`${base}/calendar/${id}?academic_year=${year()}`, body),
  deleteCalendar: (id) => AdminAPI.delete(`${base}/calendar/${id}?academic_year=${year()}`),
};
